import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { fmtDateTime } from "../lib/format";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

function StatusBadge({ accepted }) {
  if (accepted === null) return <Badge variant="outline">Nessun Termine pubblicato</Badge>;
  return accepted
    ? <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">Accettato</Badge>
    : <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-100">Da accettare</Badge>;
}

export default function TermsAcceptancesPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/super-admin/terms-acceptances").then(({ data }) => setData(data)).catch(() => toast.error("Caricamento non riuscito"));
  }, []);

  const exportCsv = async () => {
    try {
      const res = await api.get("/super-admin/terms-acceptances/export.csv", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `accettazioni-termini-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Esportazione non riuscita"); }
  };

  if (!data) return <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>;
  return (
    <div data-testid="terms-acceptances-panel" className="space-y-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="flex-1 text-sm text-slate-600" data-testid="terms-acceptances-summary">
          {data.version
            ? <>Termini in vigore dal <strong>{fmtDateTime(data.version)}</strong> · {data.accepted} accettati · {data.pending} da accettare</>
            : "Non hai ancora pubblicato i Termini e Condizioni."}
        </p>
        <Button variant="outline" size="sm" className="gap-1.5" data-testid="terms-acceptances-export-btn" onClick={exportCsv}>
          <Download className="w-4 h-4" /> Esporta CSV
        </Button>
      </div>
      <div className="overflow-x-auto rounded-xl border border-slate-200 bg-card">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
            <tr><th className="px-4 py-2">Utente</th><th className="px-4 py-2">Stato</th><th className="px-4 py-2">Accettato il</th></tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.email} data-testid={`terms-acceptance-row-${r.email}`} className="border-t border-slate-100">
                <td className="px-4 py-2"><p className="font-medium text-slate-900">{r.name || "—"}</p><p className="text-xs text-slate-500 break-all">{r.email}</p></td>
                <td className="px-4 py-2"><StatusBadge accepted={r.accepted} /></td>
                <td className="px-4 py-2 text-slate-600 whitespace-nowrap">{r.accepted_at ? fmtDateTime(r.accepted_at) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
